const PREFIX = 'SPENDING_DEMAND'

const types = {
    SET_FILTER : PREFIX+'SET_FILTER',
    SET_SPENDING_DEMAND_SELECTED_LIST : PREFIX+'SET_SPENDING_DEMAND_SELECTED_LIST',
    SET_SELECT_MODE : PREFIX+'SET_SELECT_MODE'
}

export default types